import { useEffect, useRef, useState } from 'react';
import useScript from 'hooks/useScript';
import { useLocation } from 'react-router-dom';

const UsercentricsConsent = () => {
	const location = useLocation();
	const usercentricsRootRef = useRef<HTMLElement | null>(null);
	const [loadScript, setLoadScript] = useState(false);
	const allowedPaths = ['/'];
	const shouldLoadScript = allowedPaths.includes(location.pathname);

	// Delay script loading
	useEffect(() => {
		if (shouldLoadScript && !loadScript) {
			const timer = setTimeout(() => {
				setLoadScript(true);
			}, 10000); // 10 seconds delay

			return () => clearTimeout(timer);
		}
	}, [shouldLoadScript, loadScript]);

	// Load Usercentrics script
	const scriptStatus = useScript(
		shouldLoadScript && loadScript
			? 'https://app.eu.usercentrics.eu/browser-ui/latest/loader.js'
			: null,
		{
			id: 'usercentrics-cmp',
			async: true,
			'data-eu-mode': 'true',
			'data-settings-id': 'DdWpKF2JGG6ynk',
		},
	);

	// Manage UI visibility
	useEffect(() => {
		const timer = setTimeout(() => {
			usercentricsRootRef.current = document.getElementById(
				'usercentrics-root',
			) as HTMLElement | null;

			if (usercentricsRootRef.current && shouldLoadScript) {
				usercentricsRootRef.current.style.display = 'block';
			}
		}, 10000);

		return () => {
			clearTimeout(timer);
			const usercentricsRoot = document.getElementById('usercentrics-root') as HTMLElement | null;
			if (usercentricsRoot) {
				usercentricsRoot.style.display = 'none';
			}
		};
	}, [shouldLoadScript]);

	// Log script status (remove in production)
	useEffect(() => {
		if (scriptStatus === 'error') {
			console.error('Failed to load Usercentrics script');
		} else if (scriptStatus === 'ready') {
			console.log('Usercentrics script loaded successfully');
		}
	}, [scriptStatus]);

	return null;
};

export default UsercentricsConsent;
